import { type ReactNode } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader.js";

export function TermsPage(): ReactNode {
  return (
    <div className="max-w-2xl mx-auto py-9 px-8">
      <PageHeader
        eyebrow="legal"
        title="Terms of Service"
        emphasis="Service"
        subhead="Last updated: 2026-05-16"
      />

      <div className="font-serif text-base text-inkSoft space-y-8 leading-relaxed">
        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">Using Earwise</h2>
          <p>
            Earwise is free to use for personal ear training and music study. You may not use
            it to scrape content, reverse-engineer the curriculum data, or disrupt the service
            for others.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">Your data</h2>
          <p>
            Your practice data belongs to you. We store it only to provide the sync service and
            for no other purpose. See our{" "}
            <Link to="/privacy" className="underline hover:text-accent">
              Privacy Policy
            </Link>{" "}
            for details on what we collect and how to delete it.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">No warranty</h2>
          <p>
            Earwise is provided &quot;as is&quot; without warranty of any kind, express or implied.
            We make no guarantees about uptime, data durability, accuracy of training content,
            or fitness for any particular purpose.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">Limitation of liability</h2>
          <p>
            To the extent permitted by applicable law, we are not liable for any loss of data,
            interrupted service, or other damages arising from your use of Earwise.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">Changes</h2>
          <p>
            We may update these terms occasionally. Continued use of Earwise after a change is
            posted means you accept the updated terms. We will update the date above when terms
            change.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl font-medium text-ink mb-3">Contact</h2>
          <p>
            Questions?{" "}
            <a href="mailto:calinlupa@gmail.com" className="underline hover:text-accent">
              calinlupa@gmail.com
            </a>
          </p>
        </section>
      </div>

      <footer className="mt-12 pt-6 border-t border-ink/10 flex gap-4">
        <Link to="/privacy" className="text-sm text-inkFaded hover:text-ink underline">
          Privacy Policy
        </Link>
        <Link to="/settings" className="text-sm text-inkFaded hover:text-ink underline">
          Settings
        </Link>
        <Link to="/" className="text-sm text-inkFaded hover:text-ink underline">
          Home
        </Link>
      </footer>
    </div>
  );
}
